module.exports = __webpack_public_path__ + "img/BlinkArt_Spear2H_Epic.80c1b7b9.png";